import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { StatusBanner } from 'components/shared';
import { NakedButton, Text } from '@weave/design-system';
import { ReactComponent as StatusWarningIcon } from 'images/status-warning.svg';

interface WarningStatusBannerProps {
  onReviewOptional: () => void;
}

export const WarningStatusBanner = ({ onReviewOptional }: WarningStatusBannerProps) => {
  return (
    <StatusBanner
      variant="warning"
      icon={<StatusWarningIcon />}
      title="All Required Checks Passed!"
      description="There are some optional items you could shore up before you continue though."
      action={
        <NakedButton css={ctaButton} onClick={onReviewOptional}>
          <Text as="span" weight="bold" size="medium">
            Review Optional Checks
          </Text>
        </NakedButton>
      }
    />
  );
};

const ctaButton = css`
  font-weight: ${theme.font.weight.bold};
  padding: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};

  > span {
    color: #146ef5;
  }
`;
